export const RouteInfo = [
    {
        "orgID": "60866279d774d4408635033b",
        "title": "Test Regular",
        "vehicle": [
            "TN65AP6655",
            "TN58RT8674",
            "TN09DR7652"
        ],
        "fromDate": 1631557800000,
        "toDate": 1631817000000,
        "startTime": 13.06,
        "endTime": 14.06,
        "trasitMode": "Pickup",
        "attendence": [
            "QR"
        ],
        "keywords": [
            "two"
        ],
        "holidayPattern": [
            "Ramzan"
        ],
        "status": 1,
        "routeType": "regular",
        "buildType": "Automatic",
        "createdAt": 1631507996468,
        "routeID": "613ed61c1e241503c48dbbe9",  
        "pickupDropInfo":[
            {
                "routeID": "613ed61c1e241503c48dbbe9",
                "vehRegNo": "TN65AP6655",
                "pickupInfo": [
                    {
                        "lat": 13.044456,
                        "lng": 80.267815,
                        "eta": "05:52",
                        "distance": "476.903",
                        "locationName": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India",
                        "title": "Sanabel Biriyani Point",
                        "employees": [
                            {
                                "empRefID": "Test2",
                                "name": "Sarvesh",
                                "dob": 1622764800000,
                                "gender": "Male",
                                "email": "test2@gmail.com",
                                "address": "Guindy",
                                "city": "chennai",
                                "state": "Tamil Nadu",
                                "location": {
                                    "lat": 13.044456,
                                    "lng": 80.267815,
                                    "name": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India",
                                    "ETA": "05.52",
                                    "Distance": "476.903"
                                },
                                "transportType": "company",
                                "locationName": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India",
                                "employeeID": "611226d307434a2d0f3a0bd1"
                            }
                        ]
                    },
                    {
                        "lat": 13.024236,
                        "lng": 80.260686,
                        "eta": "00:05",
                        "distance": "3.025",
                        "locationName": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India",
                        "title": "Sanabel Biriyani Point",
                        "employees": [
                            {
                                "empRefID": "Test2",
                                "name": "Pragya",
                                "dob": 1622764800000,
                                "gender": "Female",
                                "email": "test2@gmail.com",
                                "address": "Guindy",
                                "city": "chennai",
                                "state": "Tamil Nadu",
                                "location": {
                                    "lat": 13.024236,
                                    "lng": 80.260686,
                                    "name": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India",
                                    "ETA": "00.05",
                                    "Distance": "3.025"
                                },
                                "transportType": "company",
                                "locationName": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India",
                                "employeeID": "611226d307434a2d0f3a0bd4"
                            }
                        ]
                    },
                    {
                        "lat": 13.027614,
                        "lng": 80.260178,
                        "eta": "00:01",
                        "distance": "0.592",
                        "locationName": "Canal Bank Road",
                        "title": "Canal Bank Road",
                        "employees": [
                            {
                                "empRefID": "Test2",
                                "name": "Alaina",
                                "dob": 1622764800000,
                                "gender": "Female",
                                "email": "test2@gmail.com",
                                "address": "Guindy",
                                "city": "chennai",
                                "state": "Tamil Nadu",
                                "location": {
                                    "lat": 13.028741,
                                    "lng": 80.260519,
                                    "name": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India"
                                },
                                "transportType": "company",
                                "locationName": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India",
                                "employeeID": "611226d307434a2d0f3a0bd2"
                            },
                            {
                                "empRefID": "Test2",
                                "name": "Dharun",
                                "dob": 1622764800000,
                                "gender": "Male",
                                "email": "test2@gmail.com",
                                "address": "Guindy",
                                "city": "chennai",
                                "state": "Tamil Nadu",
                                "location": {
                                    "lat": 13.026468,
                                    "lng": 80.259875,
                                    "name": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India"
                                },
                                "transportType": "company",
                                "locationName": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India",
                                "employeeID": "611226d307434a2d0f3a0bd3"
                            }
                        ]
                    }
                ],
                "orgID": "60866279d774d4408635033b",
                "status": 1,
                "updatedAt": 1632753989740,
                "pickuppointID": "6151d9459917c964234e2472"
            },
            {
                "routeID": "613ed61c1e241503c48dbbe9",
                "vehRegNo": "TN58RT8674",
                "pickupInfo": [
                    {
                        "lat": 13.01864,
                        "lng": 80.258065,
                        "eta": "11:10",
                        "distance": "923.213",
                        "locationName": "Greenways Road",
                        "title": "Greenways Road",
                        "employees": [
                            {
                                "empRefID": "Test2",
                                "name": "Shivan",
                                "dob": 1622764800000,
                                "gender": "Male",
                                "email": "test2@gmail.com",
                                "address": "Guindy",
                                "city": "chennai",
                                "state": "Tamil Nadu",
                                "location": {
                                    "lat": 13.017222,
                                    "lng": 80.259214,
                                    "name": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India"
                                },
                                "transportType": "company",
                                "locationName": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India",
                                "employeeID": "611226d307434a2d0f3a0bd7"
                            },
                            {
                                "empRefID": "Test2",
                                "name": "Nithya",
                                "dob": 1622764800000,
                                "gender": "Female",
                                "email": "test2@gmail.com",
                                "address": "Guindy",
                                "city": "chennai",
                                "state": "Tamil Nadu",
                                "location": {
                                    "lat": 13.017106,
                                    "lng": 80.258827,
                                    "name": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India"
                                },
                                "transportType": "company",
                                "locationName": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India",
                                "employeeID": "611226d307434a2d0f3a0bd8"
                            },
                            {
                                "empRefID": "Test2",
                                "name": "Parvathi",
                                "dob": 1622764800000,
                                "gender": "Female",
                                "email": "test2@gmail.com",
                                "address": "Guindy",
                                "city": "chennai",
                                "state": "Tamil Nadu",
                                "location": {
                                    "lat": 13.017661,
                                    "lng": 80.25813,
                                    "name": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India"
                                },
                                "transportType": "company",
                                "locationName": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India",
                                "employeeID": "611226d307434a2d0f3a0bd6"
                            },
                            {
                                "empRefID": "Test2",
                                "name": "Murugan",
                                "dob": 1622764800000,
                                "gender": "Male",
                                "email": "test2@gmail.com",
                                "address": "Guindy",
                                "city": "chennai",
                                "state": "Tamil Nadu",
                                "location": {
                                    "lat": 13.019553,
                                    "lng": 80.256885,
                                    "name": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India"
                                },
                                "transportType": "company",
                                "locationName": "Sanabel Biriyani Point, Chennai, Tamil Nadu, India",
                                "employeeID": "611226d307434a2d0f3a0bd5"
                            }
                        ]
                    }
                ],
                "orgID": "60866279d774d4408635033b",
                "status": 1,
                "updatedAt": 1632753989740,
                "pickuppointID": "6151d9459917c964234e2473"
            }
        ],
    },
    {
        "orgID": "60866279d774d4408635033b",
        "title": "Test",
        "vehicle": [
            "TN07CP8975",
            "TN65AP6655",
            "TN58RT8674"
        ],
        "fromDate": 1630953000000,
        "toDate": 1631212200000,
        "startTime": 12.31,
        "endTime": 14.33,
        "trasitMode": "Pickup",
        "attendence": [
            "QR"
        ],
        "keywords": [
            "onee"
        ],
        "holidayPattern": [
            "Christmas",
            "Ramzan"
        ],
        "status": 1,
        "routeType": "regular",
        "buildType": "Automatic",
        "createdAt": 1631509125503,
        "routeID": "615541e09917c964234e2477"
    },
    {
        "orgID": "60866279d774d4408635033b",
        "title": "Manual route",
        "vehicle": [
            "TN07CP8975",
            "TN65AP6655"
        ],
        "fromDate": 1630953000000,
        "toDate": 1631212200000,
        "startTime": 13.41,
        "endTime": 15.42,
        "trasitMode": "Drop",
        "attendence": [
            "QR"
        ],
        "keywords": [
            "two"
        ],
        "holidayPattern": [
            "Ramzan"
        ],
        "status": 1,
        "routeType": "regular",
        "buildType": "Manual",
        "createdAt": 1631509676651,
        "routeID": "613edcac26eb439a56cc0363"
    }
];

export const campaignInfo = [{
    "orgID": "60866279d774d4408635033b",
    "campaignID":'Jalksdfa',
    "campaignName": "Camapaign New",
    "campaignFor": [
        "Pickup"
    ],
    "campaignType": [
        "sms",
        "call",
        "email",
        "push notifications"
    ],
    "branch": "6103cdc3d47110e8d00d9494",
    "shift": "6103d9cdd47110e8d00d949d",
    "routeInfo": [
        {
            "orgID": "60866279d774d4408635033b",
            "title": "Test",
            "routeID": "615541e09917c964234e2477",
            "trasitMode": "Pickup",
            "startTime": "12:31",
            "checked": false,
            "indeterminate": true,
            "vehicle": [
                "TN07CP8975",
                "TN65AP6655",
                "TN58RT8674"
            ],
            "vehicleInfo": [
                {
                    "vehRegNo": "TN07CP8975",
                    "orgID": "60866279d774d4408635033b",
                    "pickupInfo": [
                        {
                            "title": "Omr_1",
                            "eta": 9.02,
                            "radius": 300,
                            "lat": 12.96679,
                            "employees": [
                                {
                                    "employeeID": "611226d307434a2d0f3a0bd3",
                                    "empRefID": "Test2",
                                    "name": "Dharun",
                                    "checked": true,
                                    "indeterminate": false
                                }
                            ],
                            "lng": 80.24544,
                            "location": "Perungudi Post Office, Perungudi, Chennai, Tamil Nadu, India",
                            "checked": true,
                            "indeterminate": false
                        },
                        {
                            "title": "TAR_1",
                            "eta": 8.04,
                            "radius": 300,
                            "lat": 12.98647,
                            "employees": [
                                {
                                    "employeeID": "611226d307434a2d0f3a0bd2",
                                    "empRefID": "Test2",
                                    "name": "Alaina",
                                    "checked": true,
                                    "indeterminate": false
                                }
                            ],
                            "lng": 80.25165,
                            "location": "National Institute Of Fashion Technology, Canal Bank Rd, Tharamani, Chennai, Tamil Nadu, India",
                            "checked": true,
                            "indeterminate": false
                        },
                        {
                            "title": "vcy_1",
                            "eta": 8.02,
                            "radius": 300,
                            "lat": 12.97533,
                            "employees": [
                                {
                                    "employeeID": "611226d307434a2d0f3a0bd0",
                                    "empRefID": "Test2",
                                    "name": "Mathan",
                                    "checked": false,
                                    "indeterminate": false
                                }
                            ],
                            "lng": 80.22074,
                            "location": "Hotel Milan, Velachery Bypass Rd, Chennai, Tamil Nadu, India",
                            "checked": false,
                            "indeterminate": false
                        }
                    ],
                    "routeID": "615541e09917c964234e2477",
                    "status": 1,
                    "updatedAt": 1633156231294,
                    "pickuppointID": "6155422028f4a9b011831685",
                    "selectedEmp": [
                        "611226d307434a2d0f3a0bd3",
                        "611226d307434a2d0f3a0bd2"
                    ]
                }
            ]
        }
    ],
    "templateName": "Alert Services Suspended",
    "templateMessage": "Dear Manager, This Is From Group10! The Call/SMS Alert Services Will Be Suspended For The Next Two Days As Our Service Provider Is Upgrading Their Infrastructure In Order To Address Few Reported Issues Of Delayed Alerts. However, Manager Can Continue To Receive Notifications And Track The Vehicle On The Mobile App. Manager May Receive Alerts From The Existing Number, Or From A New Number After Upgrading The System. We Will Keep You Informed. Inconvenience Regretted.",
    "DNDHoliday": 1
},
{
    "orgID": "60866279d774d4408635033b",
    "campaignID":'kajsdf1',
    "campaignName": "Campaign Single Route",
    "campaignFor": [
        "Pickup"
    ],
    "campaignType": [
        "sms",
        "call",
        "email"
    ],
    "branch": "6103cde9d47110e8d00d9496",
    "shift": "6103d9cdd47110e8d00d949d",
    "routeInfo": [
        {
            "orgID": "60866279d774d4408635033b",
            "title": "Test",
            "routeID": "615541e09917c964234e2477",
            "trasitMode": "Pickup",
            "startTime": "12:31",
            "checked": true,
            "indeterminate": false,
            "vehicle": [
                "TN07CP8975",
                "TN65AP6655",
                "TN58RT8674"
            ]
        }
    ],
    "templateName": "Resuming Alert Services",
    "templateMessage": "Dear Manager, This Is From Group10! We Shall Be Resuming The Proximity Call/SMS Alert Services From Monday, 27th Sep. Thank You For Your Support.",
    "DNDHoliday": 1
},
{
    "orgID": "60866279d774d4408635033b",
    "campaignName": "Campaign All Route",
    "campaignFor": [
        "Pickup",
        "Drop"
    ],
    "campaignType": [
        "sms",
        "call",
        "email",
        "push notifications"
    ],
    "branch": "6103cdc3d47110e8d00d9494",
    "shift": "6103d9cdd47110e8d00d949d",
    "routeInfo": [
        "allRoutes"
    ],
    "templateName": "Route Delayed / Advanced_NoAlert",
    "templateMessage": "The Routes Are {Delayed/Advanced} By {Mm} Mins. Hence The Proximity Alerts Will Be {Delayed /Advanced} Accordingly.",
    "DNDHoliday": 0
}];

export const employeeFields = [
    {name:'Name',value:'name',checked:true},
    {name:'Branch',value:'branch',checked:false},
    {name:'City',value:'city',checked:false},
    {name:'Country',value:'country',checked:false},
    {name:'Email',value:'email',checked:false},
    {name:'Employee Ref ID',value:'empRefID',checked:true},
    {name:'Employee ID',value:'employeeID',checked:false},
    {name:'Gender',value:'gender',checked:false},
    {name:'Location',value:'location',checked:false},
    {name:'Mobile',value:'mobile',checked:false},
    {name:'Shift',value:'shift',checked:false},
    {name:'State',value:'state',checked:false},
    {name:'Transport Type',value:'transportType',checked:false},
    {name:'Work Location',value:'workLocation',checked:false},
]